module.exports = __webpack_public_path__ + "media/images/basic_logos/delete-orange-627b7a7c98835a7849571dc3266d8742.svg";